export default __webpack_public_path__ + "static/co-002792a9ebc4813620b7da642e249ac7.svg";